"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getRouteArtifactPath_exports = {};
__export(getRouteArtifactPath_exports, {
  getRouteArtifactPaths: () => getRouteArtifactPaths
});
module.exports = __toCommonJS(getRouteArtifactPath_exports);
var import_getPathnameFromFilePath = require("../utils/getPathnameFromFilePath");
var import_findRouteNode = require("./findRouteNode");
function getRouteArtifactPaths(href, linking, rootNode) {
  var fallback = {
    loader: href,
    preload: href
  };
  if (!(linking === null || linking === void 0 ? void 0 : linking.getStateFromPath) || !rootNode) return fallback;
  var state = linking.getStateFromPath(href, linking.config);
  var route = (0, import_findRouteNode.findRouteNodeFromState)(state, rootNode);
  if (!route) return fallback;
  var pattern = (0, import_getPathnameFromFilePath.getPathnameFromFilePath)(route.contextKey.replace(/^\.\//, "/"));
  if (route.type === "spa") {
    var hasExplicitSpaMode = route.contextKey.split("/").some(function(segment) {
      return /\+spa(?:\.|$)/.test(segment);
    });
    var path = hasExplicitSpaMode ? pattern : href;
    return {
      loader: path,
      preload: path
    };
  }
  return {
    loader: href,
    preload: route.type === "ssg" ? href : pattern
  };
}
//# sourceMappingURL=getRouteArtifactPath.js.map
